import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/views/Home.vue'
import Index from '@/views/Index.vue'
import LocalStorageService from "@/common/LocalStorageService";

const localStorageService = LocalStorageService.getService();

Vue.use(Router)

let router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      meta: {
        requiresAuth: false
      },
      component: Index
    },
    {
      path: '/licenseSearch',
      name: 'licenseSearch',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/LicenseSearch.vue')
    },
    {
      path: '/home',
      name: 'home',
      meta: {
        requiresAuth: true
      },
      component: Home
    },
    {
      path: '/timeout',
      name: 'timeout',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/Timeout.vue')
    },

    {
      path: "/application",
      name: 'application',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "request" */ './views/EditApplication.vue')
    },

    {
      path: "/checkInstructions",
      name: 'checkInstructions',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/CheckInstructions.vue')
    },

    {
      path: "/reclassify/:id/",
      name: 'reclassify',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "request" */ './views/ReclassificationApplication.vue')
    },

    {
      path: "/reclassify/draft/:draftId/",
      name: 'reclassifyDraft',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "request" */ './views/ReclassificationApplication.vue')
    },

    {
      path: "/edit/application/:id",
      name: 'editApplication',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "request" */ './views/edit/InitialApplication.vue')
    },

    {
      path: "/edit/renewal/:id",
      name: 'editRenewal',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "request" */ './views/edit/RenewalApplication.vue')
    },

    {
      path: "/addWorkDates/:id",
      name: 'addWorkDates',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "request" */ './views/update/WorkDatesApplication.vue')
    },

    {
      path: "/addSupervisor/:id",
      name: 'addSupervisor',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "request" */ './views/update/SupervisorApplication.vue')
    },

    {
      path: "/addEstablisment/:id",
      name: 'addEstablisment',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "request" */ './views/update/EstablishmentApplication.vue')
    },

    {
      path: "/application/draft/:draftId",
      name: 'applicationDraft',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "request" */ './views/EditApplication.vue')
    },

    {
      path: "/thanks",
      name: 'thanks',
      meta: {
        requiresAuth: false,
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/Thanks.vue')
    },

    {
      path: "/renewal/:token?",
      name: 'renewal',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "renewal" */ './views/RenewalApplication.vue')
    },

    {
      path: "/approve/initial/:id",
      name: 'initial',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff']
      },
      component: () => import(/* webpackChunkName: "approve" */ './views/approval/InitialReview.vue')
    },

    {
      path: "/approve/renewal/:id",
      name: 'renew',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff']
      },
      component: () => import(/* webpackChunkName: "approve" */ './views/approval/RenewalReview.vue')
    },

    {
      path: "/approve/appHistory/:id",
      name: 'appHistory',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff', 'ie-staff', 'mdh-admin']
      },
      component: () => import(/* webpackChunkName: "approve" */ './views/approval/ApplicationHistory.vue')
    },

    {
      path: "/readonly/initial/:id",
      name: 'readonlyInitial',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff', 'mdh-admin', 'readonly']
      },
      component: () => import(/* webpackChunkName: "approve" */ './views/approval/InitialReview.vue')
    },

    {
      path: "/readonly/renewal/:id",
      name: 'readonlyRenewal',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff', 'mdh-admin', 'readonly']
      },
      component: () => import(/* webpackChunkName: "approve" */ './views/approval/RenewalReview.vue')
    },

    {
      path: "/readonly/screen/:id",
      name: 'readonlyScreen',
      meta: {
        requiresAuth: true,
        authRoles: ['ie-staff', 'mdh-admin','mdh-staff']
      },
      component: () => import(/* webpackChunkName: "screen" */ './views/screening/Screen.vue')
    },

    {
      path: "/screen/:id",
      name: 'screen',
      meta: {
        requiresAuth: true,
        authRoles: ['ie-staff', 'mdh-staff', 'mdh-admin']
      },
      component: () => import(/* webpackChunkName: "screen" */ './views/screening/Screen.vue')
    },

    {
      path: "/finance-screen/:id",
      name: 'finance-screen',
      meta: {
        requiresAuth: true,
        authRoles: ['finance-staff']
      },
      component: () => import(/* webpackChunkName: "screen" */ './views/screening/FinanceScreen.vue')
    },

    {
      path: "/affirm/:id",
      name: 'affirm',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "screen" */ './views/affirm/Affirm.vue')
    },
    
    {
      path: "/transactions/:id",
      name: 'transactions',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-staff','finance-staff']
      },
      component: () => import(/* webpackChunkName: "screen" */ './views/payment/Payment.vue')
    },

    {
      path: "/pay/:id",
      name: 'pay',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "screen" */ './views/Payment.vue')
    },

    {
      path: "/emailSettings",
      name: 'emailSettings',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/admin/ManageEmails.vue')
    },
    {
      path: "/feeSettings",
      name: 'feeSettings',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/admin/ManageFees.vue')
    },
    {
      path: "/welcomeSettings",
      name: 'welcomeSettings',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/admin/ManageWelcome.vue')
    },
    {
      path: "/certificateSettings",
      name: 'certificateSettings',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/admin/ManageCertificates.vue')
    },

    {
      path: "/admin/expire",
      name: 'admin-expire',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/admin/ChangeExpiration.vue')
    },

    {
      path: "/claim",
      name: 'claim',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/ClaimApplication.vue')
    },
    {
      path: '/mdhSearch',
      name: 'mdhSearch',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin','ie-staff','mdh-staff','mnit-admin','readonly', 'finance-staff']
      },
      component: () => import(/* webpackChunkName: "admin" */ './views/MdhSearch.vue')
    },
    {
      path: '/history/:id',
      name: 'history',
      meta: {
        requiresAuth: true
      },
      component: () => import(/* webpackChunkName: "timeout" */ './views/History.vue')
    },

    {
      path: '/activeLicenses',
      name: 'activeLicenses',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin']
      },
      component: () => import(/* webpackChunkName: "reports" */ './views/reports/ActiveLicenses.vue')
    },

    {
      path: '/currentWorkload',
      name: 'currentWorkload',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin']
      },
      component: () => import(/* webpackChunkName: "reports" */ './views/reports/CurrentWorkload.vue')
    },

    {
      path: '/multipleSupervisees',
      name: 'multipleSupervisees',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin', 'mdh-staff', 'ie-staff']
      },
      component: () => import(/* webpackChunkName: "reports" */ './views/reports/MultipleSupervisees.vue')
    },

    {
      path: '/transactions',
      name: 'transactions',
      meta: {
        requiresAuth: true,
        authRoles: ['finance-staff']
      },
      component: () => import(/* webpackChunkName: "reports" */ './views/reports/Transactions.vue')
    },

    {
      path: "/updateUser",
      name: 'updateUser',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/UpdateUser.vue')
    },

    {
      path: "/updateAdmin/:id",
      name: 'updateAdmin',
      meta: {
        requiresAuth: true,
        authRoles: ['mdh-admin','mnit-admin']
      },
      component: () => import(/* webpackChunkName: "thanks" */ './views/UpdateAdmin.vue')
    },

    {
      path: "/message/:id",
      name: 'message',
      meta: {
        requiresAuth: true,
      },
      component: () => import(/* webpackChunkName: "request" */ './views/protected/Message.vue')
    },

    {
      path: '/unauthorized',
      name: 'unauthorized',
      meta: {
        requiresAuth: false
      },
      component: () => import(/* webpackChunkName: "unauthorized" */ './views/Unauthorized.vue')
    },

    {
      path: '*', 
      component: Home
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak && router.app.$keycloak.authenticated) {
      if (to.meta.authRoles) {
        let hasRole = false
        for (var i = 0; i < to.meta.authRoles.length; i++) {
          if (router.app.$keycloak.hasResourceRole(to.meta.authRoles[i])) {
            hasRole = true;
          }
        }
        if (hasRole) {
          next()
        } else {
          router.push('unauthorized') 
        }
      } else {
        next();
      }
    } else {
      const url = localStorageService.getLoginUrl()
      window.location.replace(url)
    }
  } else {
    next()
  }
})

export default router